import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.scss'],
  standalone: false
})
export class StoreComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
